import dayjs from 'dayjs';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@common/constant/date';
import { FILTER_PICKER_RANGE_MODE } from '@common/constant/mode';

export const convertTimeToHHMMSS = (timeWithMilliseconds) => {
  // Split the string by the dot and take the first element
  const parts = timeWithMilliseconds.split('.');
  const timeWithoutMilliseconds = parts[0];
  return timeWithoutMilliseconds;
};

export const timeDateDisplay = (value) => {
  return value ? dayjs(value).format(DATE_FORMAT) : '';
};

export const dateTimeFormat = (value) => {
  return value ? dayjs(value).format(DATE_TIME_FORMAT) : '';
};

export const formatTimezoneOffset = (offsetMinutes) => {
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absOffset = Math.abs(offsetMinutes);
  const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
  const minutes = String(absOffset % 60).padStart(2, '0');
  return `${sign}${hours}:${minutes}`;
};

export const getDateRangeSuffix = (
  fromDate,
  toDate,
  modeFilter,
  dateFormat = 'YYYY/MM',
) => {
  const formattedFromDate = dayjs(fromDate).format(dateFormat);
  const formattedToDate = dayjs(toDate).format(dateFormat);
  return modeFilter === FILTER_PICKER_RANGE_MODE
    ? `${formattedFromDate}-${formattedToDate}`
    : formattedFromDate;
};
